<div class="loader-bg">
    <img width="300px" src="../../../../assets/Home-Connect/loaderBlack.gif" alt="loader">
</div>
